import React from 'react';

const List = (props) => {
  const {
    Container = 'div',
    className = '',
    items,
    renderItem,
  } = props;

  return (
    <Container className={className}>
      {items.map(renderItem)}
    </Container>
  );
};

export default List;


// WEBPACK FOOTER //
// ./src/modules/common/components/List.js